<template>
  <div class="company-media-container">
    <h1>扫描关注官方微信</h1>

    <ul class="company-media-ul">
      <li>
        <span><img src="../../../static/image/exgs.png" alt="" /></span>
        <span>e行高速App</span>
      </li>

      <li>
        <span><img src="../../../static/image/jsgs.jpg" alt="" /></span>
        <span>“江苏高速”公众号</span>
      </li>

      <li>
        <span><img src="../../../static/image/jtkg.jpg" alt="" /></span>
        <span>江苏交通控股党建</span>
      </li>

      <li>
        <span><img src="../../../static/image/xfh.png" alt="" /></span>
        <span>先锋荟App</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CompanyMedia',
};
</script>

<style scoped lang="scss">
@import '@/assets/css/common.scss';

.company-media-container {
  margin-top: 114px;
  padding: 0 40px;
  box-sizing: border-box;
  overflow: hidden;

  > h1 {
    text-align: center;
    font-size: 42px;
    font-weight: 500;
    color: #333333;
    line-height: 59px;
    margin-bottom: 74px;
  }

  ul.company-media-ul {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: start;
      width: 45%;
      margin-bottom: 75px;

      span {
        img {
          width: 176px;
          height: 176px;
        }
      }

      span:last-child {
        font-size: 26px;
        font-weight: 500;
        color: #262626;
        line-height: 40px;
        margin-top: 35px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/CompanyMedia.vue